import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Flag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { cartCount } from "@/lib/cart";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [count, setCount] = useState(cartCount());

  useEffect(() => {
    const sync = () => setCount(cartCount());
    window.addEventListener("cartUpdated", sync);
    return () => window.removeEventListener("cartUpdated", sync);
  }, []);

  return (
    <header className="border-b border-gray-200 bg-white">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <Link to="/" className="flex items-center gap-2 font-extrabold text-fairway-700">
          <Flag size={22} />
          First Aid Golf
        </Link>
        <div className="flex items-center gap-5 text-sm font-medium">
          <Link to="/" className="hover:text-fairway-700">
            For Events
          </Link>
          <Link to="/membership" className="hover:text-fairway-700">
            Refill Membership
          </Link>
          {user?.is_admin && (
            <Link to="/admin/orders" className="hover:text-fairway-700">
              Admin
            </Link>
          )}
          {user ? (
            <>
              <Link to="/dashboard" className="hover:text-fairway-700">
                My Orders
              </Link>
              <button onClick={logout} className="text-gray-500 hover:text-gray-800">
                Log out
              </button>
            </>
          ) : (
            <Link to="/login" className="hover:text-fairway-700">
              Log in
            </Link>
          )}
          <Link to="/cart" className="relative">
            <ShoppingCart size={20} />
            {count > 0 && (
              <span className="absolute -right-2 -top-2 rounded-full bg-fairway-600 px-1.5 text-xs font-bold text-white">
                {count}
              </span>
            )}
          </Link>
        </div>
      </nav>
    </header>
  );
}
